import { Box, Button, SxProps, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import MapIcon from "@mui/icons-material/Map"
import NearMeIcon from "@mui/icons-material/NearMe"
import { StoreIcon } from "components/icons"
import { useTranslation } from "providers/i18n"
import { useMemo } from "react"
import { getIcon } from "utils/icon"
import { useHomeInstructionCards } from "extensions/iconsiam/hooks/home-instruction-cards/useHomeInstructionCards"

interface HomeInstructionCardsProps {
  sx?: SxProps
}

export const HomeInstructionCards = ({ sx }: HomeInstructionCardsProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { enable, cards } = useHomeInstructionCards()

  const styleOverrides =
    theme.components?.["HomeInstructionCards"]?.styleOverrides || {}
  const { root, card, cardIcon, cardLabel, cardSubLabel } = styleOverrides

  const navigationIcon = useMemo(
    () => getIcon(theme?.assets?.home?.navigation) || <MapIcon />,
    [theme]
  )

  const storeIcon = useMemo(
    () => getIcon(theme?.assets?.home?.store) || <StoreIcon />,
    [theme]
  )

  const DEFAULT_CARDS = [
    {
      key: "touch",
      icon: navigationIcon,
      label: "Touch to start",
      subLabel: "แตะเพื่อเริ่มต้น",
    },
    {
      key: "store",
      icon: storeIcon,
      label: "Select a store",
      subLabel: "เลือกร้านค้า ร้านอาหาร\nหรือกิจกรรม",
    },
    {
      key: "direction",
      icon: <NearMeIcon />,
      label: "Get walking directions",
      subLabel: "ดูเส้นทางนำทาง",
    },
  ]

  const items = cards.length
    ? cards.map(({ key, icon, label, subLabel }) => ({
        key,
        label,
        subLabel,
        icon: getIcon(icon),
      }))
    : DEFAULT_CARDS

  if (!enable) return null

  return (
    <Box sx={deepmerge(root, sx)}>
      {items.map(({ key, icon, label, subLabel }) => (
        <Button key={key} disableTouchRipple sx={card}>
          <Box sx={cardIcon}>{icon}</Box>
          <Typography sx={cardLabel}>{t(label)}</Typography>
          <Typography sx={cardSubLabel}>{t(subLabel)}</Typography>
        </Button>
      ))}
    </Box>
  )
}
